import React, { useContext, useEffect } from 'react';

import { getAllReports } from '../../../../store/slices/reportSlice';
import { useAppDispatch } from '../../../../store/configureStore';

// utilities
import { handleImageSave } from '../../utilities';

// components
import { InsertDriveFile } from '@mui/icons-material';
import ButtonTextIcon from '../../../../components/buttons/ButtonTextIcon';
import ModalEnum from '../../../../components/modals/Report/enums/ModalEnum';
import { ModalContext } from '../../../../components/modals/Report';

export default function ButtonAddToReport({ groupImageData = {} }) {
  const { handleModal } = useContext(ModalContext);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAllReports());
  }, []);

  const handleOnClick = () => {
    handleImageSave(groupImageData);

    // TODO: DETERMINE BETTER SAVE BEFORE NEXT PREVIEW
    handleModal(ModalEnum.IMAGE_EDITOR_REPORT_MODAL);
  };

  return (
    <ButtonTextIcon tooltip="Report" icon={<InsertDriveFile />} onClick={handleOnClick}>
      Add To Report
    </ButtonTextIcon>
  );
}
